import { FunctionComponent } from 'react';
import { Image, Text, Stack } from '@chakra-ui/react'
import { images } from '../support/imageSupport';

export interface BtListViewParams {
    title: string
    image: string
    visible: boolean
    as?: any
}


const BtListView: FunctionComponent<BtListViewParams> = ({ title, image, as }) => {


    return (
        <Stack spacing={5} direction={['row', 'row']} align='center'>
            {image !== null && <Image src={images(image)} />}
            {as !== undefined && <Text as={as} fontSize='xl'  >{title}</Text>}
            {as === undefined && <Text>{title}</Text>}
        </Stack>

    )
}

export default BtListView;
